import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import stl from "./UnbxdMobileTextSearch.module.css";
import useUnbxdTextSearch from "../../../../../../../common/hooks/useUnbxdTextSearch";
import loadable from "@loadable/component";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import useHelpers from "@hooks/useHelpers";
import { useAuthActions } from "@/_MiniApps/auth/AuthContext";
import { createPortal } from "react-dom";
import useLocalStorage from "@hooks/useLocalStorage";
var fallback = {
  fallback: null
};
var UnbxdMobileTextSearchPopUp = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "UnbxdMobileTextSearchPopUp";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "UnbxdMobileTextSearchPopUp" */"./UnbxdMobileTextSearchPopUp");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./UnbxdMobileTextSearchPopUp");
    }
    return eval('require.resolve')("./UnbxdMobileTextSearchPopUp");
  }
}, fallback);
var UnbxdMobileTextSearch = function UnbxdMobileTextSearch(_ref) {
  var referral_location = _ref.referral_location;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    showPopup = _useState[0],
    setShowPopup = _useState[1];
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var searchTermParam = searchParams.get("text");
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _useAuthActions = useAuthActions(),
    syncSearchHistoryOnLogin = _useAuthActions.syncSearchHistoryOnLogin; // Access the function
  var navigate = useNavigate();
  var _useUnbxdTextSearch = useUnbxdTextSearch(setShowPopup),
    searchTerm = _useUnbxdTextSearch.searchTerm,
    searchTermSuggestions = _useUnbxdTextSearch.searchTermSuggestions,
    handleSearchTermChange = _useUnbxdTextSearch.handleSearchTermChange,
    handleTextSearch = _useUnbxdTextSearch.handleTextSearch,
    setSearchTerm = _useUnbxdTextSearch.setSearchTerm,
    setSearchTermSuggestions = _useUnbxdTextSearch.setSearchTermSuggestions;
  var _useLocalStorage = useLocalStorage(false),
    setLocalStorage = _useLocalStorage.setLocalStorage;
  useEffect(function () {
    if (showPopup) {
      document.body.style.overflow = "hidden";
      setLocalStorage('text_search_referral_location', referral_location);
    } else {
      document.body.style.overflow = "unset";
    }
  }, [showPopup]);
  useEffect(function () {
    if (!searchTermParam) {
      setSearchTerm("");
      setSearchTermSuggestions([]);
      return;
    }
    setSearchTerm(searchTermParam);
  }, [searchTermParam]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: [stl.textSearch, "abSearchTextClass"].join(" "),
    onClick: function onClick() {
      setShowPopup(true);
      syncSearchHistoryOnLogin();
    },
    id: "unbxd-text-mobile-search_bar-container"
  }, !searchTermParam ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "interActiveGray"
  }, t("ابحث عن الماركة او الموديل", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement("img", {
    className: stl.searchIconN,
    src: CDN_LINK + "/assets/images/text-search-icon.svg",
    width: 15,
    height: 15,
    alt: "text-search-icon",
    "aria-label": "text-search-icon"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: stl.active
  }, searchTermParam), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/clear.svg",
    alt: "",
    className: "".concat(stl.clear, " hasEvents"),
    onClick: function onClick(e) {
      e.stopPropagation();
      setSearchTerm("");
      setSearchTermSuggestions([]);
      navigate(createUrl("/filters"));
    }
  }))), showPopup && /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement(UnbxdMobileTextSearchPopUp, {
    searchTerm: searchTerm,
    imgClick: function imgClick() {
      setShowPopup(false);
      setSearchTerm("");
    },
    handleSearchTermChange: handleSearchTermChange,
    handleTextSearch: handleTextSearch,
    searchTermSuggestions: searchTermSuggestions
  }), document.getElementById("BodyPortal")));
};
export default UnbxdMobileTextSearch;